import { useSnapshot } from 'valtio'
import uiState from '../data'
import { AnimatePresence, motion } from 'framer-motion'
import { isMobile } from 'react-device-detect'
import { useState } from 'react'
import { windowSizeState } from '../utils/windowSize'

const InfoPage = ({ event }) => {
  const { visible, data, language } = useSnapshot(uiState[event])
  const [isLanguageHover, setIsLanguageHover] = useState(false)
  const [isEnterHover, setIsEnterHover] = useState(false)
  const { mobileMode } = useSnapshot(windowSizeState)
  const [tipPosition, setTipPosition] = useState({ x: 0, y: 0 })
  const [showHoverTip, setShowHoverTip] = useState(false)

  const goVR = () => {
    let currentUrl = window.location.href
    let newUrl = currentUrl.replace('/start/start.html', '/vr/v0.html')
    window.location.href = newUrl
    uiState[event].visible = false
  }
  return (
    <>
      {visible && mobileMode && (
        <AnimatePresence>
          {visible && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
              className='screen-setting overflow-hidden fixed top-0 left-0'
            ></motion.div>
          )}
        </AnimatePresence>
      )}

      <AnimatePresence>
        {visible && mobileMode && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className='screen-setting overflow-hidden fixed top-0 left-0'
          >
            <img
              src='../startMedia/intro_bg_phone.png'
              alt='背景圖'
              className='w-full h-full'
            />

            <div className=' absolute top-0 left-0 w-[16%] h-full '>
              <img
                src='../startMedia/intro_title.png'
                alt='logo'
                className='w-[35%] absolute top-[50px] left-1/2 -translate-x-1/2 landscapePhone:top-[16px] landscapePhone:h-[70%] landscapePhone:w-auto'
              />
            </div>
            <div className='w-[75%] h-[75%]  absolute top-1/2 left-[20%] -translate-y-1/2 flex flex-col items-end portraitBigPh:h-[70%] landscapePhone:h-[50%]'>
              <div className='text-[30px] portraitBigPh:text-[24px] w-full NotoSerifB text-left mb-4 flex items-center landscapePhone:text-[24px]'>
                <div>關於展覽</div>
                <div className='h-[2px] flex-1 bg-mainBlack-100 mx-[12px]'></div>
                <img
                  src={
                    !isMobile && language === 'zh' && isLanguageHover
                      ? '../startMedia/btn_en_hover.png'
                      : !isMobile && language === 'en' && isLanguageHover
                      ? '../startMedia/btn_zh_hover.png'
                      : language === 'zh'
                      ? '../startMedia/btn_en.png'
                      : '../startMedia/btn_zh.png'
                  }
                  alt='切換語言按鈕'
                  className='w-[70px] cursor-pointer portraitBigPh:w-[60px] landscapePhone:w-[60px]'
                  onClick={() => {
                    if (language === 'zh') {
                      uiState[event].language = 'en'
                    } else {
                      uiState[event].language = 'zh'
                    }
                  }}
                  onMouseEnter={() => {
                    setIsLanguageHover(true)
                  }}
                  onMouseLeave={() => {
                    setIsLanguageHover(false)
                  }}
                />
              </div>

              <div
                className={`w-full  pr-[20px] whitespace-pre-wrap overflow-y-scroll relative infoScroll ${
                  language === 'zh' ? 'text-justify' : 'text-start'
                }`}
              >
                <p className=' text-mainGreen-100 text-[18px] NotoSerifM mb-4 '>
                  {language === 'zh' ? data.zh.title1 : data.en.title1}
                </p>
                <p className='text-[17px] NotoSerifR  mb-6'>
                  {language === 'zh' ? data.zh.content1 : data.en.content1}
                </p>
                <p className=' text-mainGreen-100 text-[18px] NotoSerifM mb-4'>
                  {language === 'zh' ? data.zh.title2 : data.en.title2}
                </p>
                <p className='text-[17px] NotoSerifR mb-6'>
                  {language === 'zh' ? data.zh.content2 : data.en.content2}
                </p>
                <p className=' text-mainGreen-100 text-[18px] NotoSerifM mb-4'>
                  {language === 'zh' ? data.zh.title3 : data.en.title3}
                </p>
                <p className='text-[17px] NotoSerifR  mb-6'>
                  {language === 'zh' ? data.zh.content3 : data.en.content3}
                </p>
                <p className=' text-mainGreen-100 text-[18px] NotoSerifM mb-4'>
                  {language === 'zh' ? data.zh.title4 : data.en.title4}
                </p>
                <p className='text-[17px] NotoSerifR '>
                  {language === 'zh' ? data.zh.content4 : data.en.content4}
                </p>
              </div>
            </div>
            <div className='absolute bottom-[5%] right-[8%]'>
              <img
                src={
                  !isMobile && isEnterHover
                    ? '../startMedia/intro_btn_hover.png'
                    : '../startMedia/intro_btn.png'
                }
                alt='進入展覽按鈕'
                className='  w-[80px] cursor-pointer'
                onClick={goVR}
                onMouseEnter={() => {
                  setIsEnterHover(true)
                }}
                onMouseLeave={() => {
                  setIsEnterHover(false)
                }}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {visible && !mobileMode && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className='screen-setting overflow-hidden fixed top-0 left-0'
          >
            {showHoverTip && !isMobile && (
              <motion.div
                className=' fixed top-0 left-0 tracking-[1px] z-50  NotoSerifM flex'
                animate={{ x: tipPosition.x - 28, y: tipPosition.y - 35 }}
                transition={{ duration: 0 }}
              >
                <div className='mr-[5px]'>Enter</div>
                <img
                  src='../startMedia/right-arrow.png'
                  alt=''
                  className='w-[15px] object-contain'
                />
              </motion.div>
            )}
            <img
              src='../startMedia/intro_bg_pc.png'
              alt='背景圖'
              className='w-full h-full'
            />
            <div
              className=' absolute right-[8%] bottom-[8%] w-[6%] smallLaptop:w-[8%] landscapePad:w-[8%] cursor-pointer'
              onMouseMove={(e) => {
                setTipPosition({ x: e.clientX, y: e.clientY })
              }}
              onMouseEnter={() => {
                setShowHoverTip(true)
              }}
              onMouseLeave={() => {
                setShowHoverTip(false)
              }}
            >
              <img
                src={
                  !isMobile && isEnterHover
                    ? '../startMedia/intro_btn_hover.png'
                    : '../startMedia/intro_btn.png'
                }
                alt='進入展覽按鈕'
                className=' w-full object-contain'
                onClick={goVR}
                onMouseEnter={() => {
                  setIsEnterHover(true)
                }}
                onMouseLeave={() => {
                  setIsEnterHover(false)
                }}
              />
            </div>
            <div className=' absolute top-0 left-0 w-[9%] h-full '>
              <img
                src='../startMedia/intro_title.png'
                alt='logo'
                className='w-[35%] absolute top-[50px] left-1/2 -translate-x-1/2'
              />
            </div>
            <div className='w-[60%] h-[85%]  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-end'>
              <div className='text-[30px] w-full NotoSerifB text-left mb-4 flex items-center'>
                <div className='mr-8'>關於展覽</div>
                <img
                  src={
                    !isMobile && language === 'zh' && isLanguageHover
                      ? '../startMedia/btn_en_hover.png'
                      : !isMobile && language === 'en' && isLanguageHover
                      ? '../startMedia/btn_zh_hover.png'
                      : language === 'zh'
                      ? '../startMedia/btn_en.png'
                      : '../startMedia/btn_zh.png'
                  }
                  alt='切換語言按鈕'
                  className='w-[70px] cursor-pointer'
                  onClick={() => {
                    if (language === 'zh') {
                      uiState[event].language = 'en'
                    } else {
                      uiState[event].language = 'zh'
                    }
                  }}
                  onMouseEnter={() => {
                    setIsLanguageHover(true)
                  }}
                  onMouseLeave={() => {
                    setIsLanguageHover(false)
                  }}
                />
              </div>
              <div className='w-full h-[70%] fixed top-0  right-0 border-l-2 border-mainBlack-100 translate-x-[50px] translate-y-[60px]'></div>
              <div
                className={`w-[calc(100%-50px)] pl-[30px] pr-[50px] whitespace-pre-wrap overflow-y-scroll relative infoScroll text-justify ${
                  language === 'zh' ? ' tracking-[3px]' : ' tracking-[0px]'
                }`}
              >
                <p className=' text-mainGreen-100 text-[18px]  NotoSerifM mb-4 '>
                  {language === 'zh' ? data.zh.title1 : data.en.title1}
                </p>
                <p className='text-[17px]  NotoSerifR  mb-6'>
                  {language === 'zh' ? data.zh.content1 : data.en.content1}
                </p>
                <p className=' text-mainGreen-100 text-[18px]  NotoSerifM  mb-4'>
                  {language === 'zh' ? data.zh.title2 : data.en.title2}
                </p>
                <p className='text-[17px] NotoSerifR mb-6'>
                  {language === 'zh' ? data.zh.content2 : data.en.content2}
                </p>
                <p className=' text-mainGreen-100 text-[18px] NotoSerifM mb-4'>
                  {language === 'zh' ? data.zh.title3 : data.en.title3}
                </p>
                <p className='text-[17px] NotoSerifR  mb-6'>
                  {language === 'zh' ? data.zh.content3 : data.en.content3}
                </p>
                <p className=' text-mainGreen-100 text-[18px] NotoSerifM mb-4'>
                  {language === 'zh' ? data.zh.title4 : data.en.title4}
                </p>
                <p className='text-[17px] NotoSerifR '>
                  {language === 'zh' ? data.zh.content4 : data.en.content4}
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default InfoPage
